<button type="button"
        class="btn btn-outline-primary ms-3"
        (click)="clickOpenSidenav()"
        matRipple [matRippleUnbounded]="false"
        [matRippleCentered]="true"
        [matRippleRadius]="200"><i class="fa fa-lg fa-bars"></i></button>
